module.exports = __webpack_public_path__ + "img/diva.10eb9fd7.svg";